import React from "react";
import PropTypes from "prop-types";

import UserWrapper from "apps/discovery/containers/user/UserWrapper";

import UserRow from "shared/components/UserRow";
import UserRowPlaceholder from "shared/components/UserRowPlaceholder";
import "./EssayWithUserRow.scss";

const EssayWithUserRow = (props) => {
	// Return loading scaffold for the card.
	if (props.placeholder) {
		return (
			<div className="essayWithUserRow">
				<div className="essayWithUserRow-wrapper">
					<div className="essayWithUserRow-body" />
					<UserRowPlaceholder />
				</div>
			</div>
		);
	}

	// Can't do anything without this 🤷🏻‍♂️
	if (!props.user || !props.user.story) {
		return null;
	}

	const {
		user: {
			story: {
				sectionTitle,
				title,
				contents,
				image_url: picUrl
			},
			...user
		},
	} = props;

	return (
		<UserWrapper className="essayWithUserRow" {...props}>
			<div className="essayWithUserRow-wrapper">
				<div className="essayWithUserRow-body">
					<h3 className="essayWithUserRow-body-category">{sectionTitle}</h3>
					<h3 className="essayWithUserRow-body-title">{title}</h3>
					<p className="essayWithUserRow-body-content" dangerouslySetInnerHTML={{ __html: contents }} />
					{picUrl && (
						<img
							className="essayWithUserRow-body-image"
							alt="Essay Pic"
							src={picUrl}
						/>
					)}
				</div>
				<UserRow {...user} shouldDisablePopover />
			</div>
		</UserWrapper>
	);
};

EssayWithUserRow.propTypes = {
	user: PropTypes.shape({
		story: PropTypes.shape({
			contents: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			sectionTitle: PropTypes.string.isRequired,
			image_url: PropTypes.string,
		}).isRequired,
	}),
	placeholder: PropTypes.bool,
};
EssayWithUserRow.defaultProps = {
	user: null,
	placeholder: false,
};

export default EssayWithUserRow;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/user/EssayWithUserRow.jsx